<template>
	<div>
		<a-page-header style="background: #fff;" title="积分商品管理" :breadcrumb="{props:{routes:[{breadcrumbName:'首页'},{breadcrumbName:'积分商品管理'}]}}">
			<template slot="extra">
				<a-button type="primary" @click="addModal = true">
					添加积分商品
				</a-button>
			</template>
			<a-form-model layout="inline" :form="searchForm" @submit="searchSubmit">
				<a-form-model-item>
					<a-input style="width: 300px" placeholder="请输入商品名称" v-model="searchForm.word" />
				</a-form-model-item>
				<a-form-model-item>
					<a-button type="primary" html-type="submit">
						搜索
					</a-button>
				</a-form-model-item>
			</a-form-model>
		</a-page-header>

		<!-- 列表 -->
		<div class="mainBox">
			<div class="contentBox">
				<a-table :columns="columns" :dataSource="list" rowKey="id" :pagination="pagination" :loading="loading" @change="handleTableChange">
					<span slot="integralGoodsThumb" slot-scope="integralGoodsThumb">
						<a-avatar shape="square" :src="integralGoodsThumb" :size="70" />
					</span>
					<span slot="integralGoodsPrice" slot-scope="integralGoodsPrice">
						<span style="font-weight: 700;font-size: 20px;">
							{{integralGoodsPrice}} 积分
						</span>
					</span>
					<span slot="integralGoodsStatus" slot-scope="integralGoodsStatus">
						<a-tag v-if="integralGoodsStatus == true" color="green">上架</a-tag>
						<a-tag v-if="integralGoodsStatus == false" color="red">下架</a-tag>
					</span>
					<span slot="action" slot-scope="text, record">
						<a @click="toDetail(record.id)">详情</a>
						<a-divider type="vertical" />
						<a-popconfirm title="请确认是否删除？" okText="是" cancelText="否" @confirm="del(record.id)">
							<a href="javascript:;" style="color: #ff4d4f;">删除</a>
						</a-popconfirm>
					</span>
				</a-table>
			</div>
		</div>

		<!-- 添加积分商品弹出 -->
		<a-modal title="添加商品" v-model="addModal" @ok="addSubmit" cancelText="取消" okText="下一步" width="50%">
			<a-form-model ref="addForm" :model="addForm" :rules="addRules" :label-col="{ span: 8 }" :wrapper-col="{ span: 10 }">
				<a-form-model-item label="商品名称" prop="integralGoodsName">
					<a-input v-model="addForm.integralGoodsName" placeholder="请输入商品名称" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	var storage = window.localStorage
	const columns = [{
			title: 'ID',
			dataIndex: 'id',
		},
		{
			title: '商品名称',
			dataIndex: 'integralGoodsName',
			scopedSlots: {
				customRender: 'integralGoodsName'
			},
		},
		{
			title: '缩略图',
			dataIndex: 'integralGoodsThumb',
			scopedSlots: {
				customRender: 'integralGoodsThumb'
			},
		},
		{
			title: '所需积分',
			dataIndex: 'integralGoodsPrice',
			scopedSlots: {
				customRender: 'integralGoodsPrice'
			},
		},
		{
			title: '库存',
			dataIndex: 'integralGoodsInventory',
			scopedSlots: {
				customRender: 'integralGoodsInventory'
			},
		},{
			title: '销量',
			dataIndex: 'integralGoodslSales',
		},
		{
			title: '状态',
			dataIndex: 'integralGoodsStatus',
			scopedSlots: {
				customRender: 'integralGoodsStatus'
			},
		},
		{
			title: '添加时间',
			dataIndex: 'addTime',
		},
		{
			title: '操作',
			dataIndex: 'action',
			scopedSlots: {
				customRender: 'action'
			},
		},
	];

	export default {
		data() {
			return {
				columns,
				list: [],
				storeList: [],
				searchForm: {},
				pagination: {
					pageSize: 20,
					total: 0,
					current: 1
				},
				addForm: {},
				addModal: false,
				loading: false,
				addRules: {
					integralGoodsName: [{
						required: true,
						message: '请填写商品名称',
						trigger: 'blur'
					}],
				},
			};
		},

		mounted() {
			this.getList()
		},

		methods: {
			dateChange(value, dateString) {
				console.log(value, dateString)
				this.searchForm.dateBegin = dateString[0]
				this.searchForm.dateEnd = dateString[1]
			},

			toDetail(id) {
				this.$router.push('/integral/integralDetail?id=' + id)
			},

			addSubmit() {
				this.$refs.addForm.validate(valid => {
					if (valid) {
						this.$http.post('/admin/index.php/admin/Shop/integralSave', {
							integralGoodsName: this.addForm.integralGoodsName,
						}).then(res => {
							if (res.data.code == 1) {
								this.$router.push('/integral/integralDetail?id=' + res.data.data)
							} else {
								this.$message.error(res.data.msg);
							}
						})
					}
				});
			},

			del(id) {
				this.$http.post('/admin/index.php/admin/Shop/integralDel', {
					id: id
				}).then((res) => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
						this.getList();
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			searchSubmit(e) {
				e.preventDefault()
				this.getList()
			},

			handleTableChange(pagination, filters, sorter) {
				this.list = []
				this.pagination.current = pagination.current
				this.pagination.field = sorter.field
				this.pagination.order = sorter.order
				this.getList()
			},

			getList() {
				this.loading = true
				var data = {
					page: this.pagination.current,
					num: this.pagination.pageSize,
					field: this.pagination.field,
					order: this.pagination.order,
					word: this.searchForm.word,
				}
				this.$http.post('/admin/index.php/admin/Shop/integralList', data).then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.list = res.data.data
						this.pagination.total = res.data.count
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},
		}
	}
</script>

<style scoped="">
	.ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.ant-upload-select-picture-card .ant-upload-text {
		margin-top: 8px;
		color: #666;
	}
</style>
